import { message } from "antd";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { getParticipantesEntregas } from "../../../../services/financiero/participantesEntregasService";

export const exportarParticipantesEntregasExcel = async (proyectos = []) => {
  try {
    const res = await getParticipantesEntregas(proyectos);
    const datos = res || [];
    if (!datos.length) {
      message.warning("No hay datos para exportar");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Reporte");
    const totalColumnas = 22;
    worksheet.mergeCells(1, 1, 1, totalColumnas);
    const title = worksheet.getCell(1, 1);
    title.value = "REPORTE DE PARTICIPANTES Y ENTREGAS";
    title.font = {
      size: 16,
      bold: true,
      color: { argb: "FFFFFFFF" }
    };
    title.alignment = {
      horizontal: "center",
      vertical: "middle"
    };
    title.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF002060" } 
    };
    worksheet.columns = [
      { key: "codigo_proyecto", width: 12 },
      { key: "nombre_proyecto", width: 30 },
      { key: "subregion_pdet", width: 25 },
      { key: "departamento", width: 16 },
      { key: "municipio", width: 16 },
      { key: "tipo_zona", width: 18 },
      { key: "nombre_zona", width: 25 },
      { key: "quien_ejecuta", width: 20 },
      { key: "nombre_participante", width: 30 },
      { key: "tipo_identificacion", width: 22 },
      { key: "numero_identificacion", width: 18 },
      { key: "sexo", width: 10 },
      { key: "fecha_nacimiento", width: 18 },
      { key: "linea_economica_principal", width: 28 },
      { key: "nivel_escolaridad", width: 25 },
      { key: "organizacion", width: 25 },
      { key: "estado_participante", width: 18 },
      { key: "numero_po", width: 18 },
      { key: "nombre_producto", width: 35 },
      { key: "cantidad_entregada", width: 18 },
      { key: "valor_total_entregado", width: 22 },
      { key: "estado_entrega", width: 18 }
    ];
    const headers = [
      "Código Proyecto",
      "Nombre del Proyecto",
      "Subregión PDET",
      "Departamento",
      "Municipio",
      "Tipo de Zona",
      "Zona de Influencia",
      "Implementador",
      "Nombre del Participante",
      "Tipo de Identificación",
      "Número de Identificación",
      "Sexo",
      "Fecha de Nacimiento",
      "Línea Económica",
      "Nivel de Escolaridad",
      "Organización",
      "Estado del Participante",
      "Número de PO",
      "Nombre del Producto",
      "Cantidad Entregada",
      "Valor Total Entregado (COP)",
      "Estado de la Entrega"
    ];
    worksheet.getRow(2).values = headers;
    const headerRow = worksheet.getRow(2);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF1F4E78" }
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
    datos.forEach((row) => {
      const newRow = worksheet.addRow({
        ...row,
        fecha_nacimiento: row.fecha_nacimiento
          ? dayjs(row.fecha_nacimiento).format("YYYY-MM-DD")
          : "",
        cantidad_entregada: Number(row.cantidad_entregada),
        valor_total_entregado: Number(row.valor_total_entregado)
      });
      newRow.eachCell((cell) => {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      });
    });
    worksheet.getColumn("valor_total_entregado").numFmt = '"$"#,##0';
    worksheet.views = [{ state: "frozen", ySplit: 2 }];
    const totalFilas = worksheet.rowCount;
    for (let i = 1; i <= totalFilas; i++) {
      const row = worksheet.getRow(i);
      for (let j = 1; j <= totalColumnas; j++) {
        const cell = row.getCell(j);
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      }
    }
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `Reporte_Participantes_Entregas_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
    );
  } catch (error) {
    console.error(error);
    message.error("Error generando exportable");
  }
};